import React from 'react';
import { FilePreview, Popup, WysiwygField } from 'features/nekst-widgets';
import { MarketRequest, useTeamSetupAreasService } from 'nekst-api';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  ShowContext,
  Text,
  TextField, usePopupManager,
  useShowContextRequired
} from 'ui-builder';
import RequestStatusField from './RequestStatusField';
import { useAllTeamSetupAreasContextRequired } from '../TeamSetupAreaContext';

function AttachedFiles() {
  const { data } = useShowContextRequired<MarketRequest>();

  if (data.attachedFiles.length > 0) {
    return (
      <>
        {data.attachedFiles.map((item) => (
          <FilePreview data={item._file} key={item.title} />
        ))}
      </>
    );
  } else {
    return <Text>No files attached</Text>;
  }
}

function ApplyMarketField(props: {
  data: MarketRequest,
}) {

  const teamSetupAreasContext = useAllTeamSetupAreasContextRequired();

  const teamSetupAreasService = useTeamSetupAreasService();

  const popupManager = usePopupManager();

  if (props.data._setupArea) {
    const isAdded = !!teamSetupAreasContext.areas.find((item) => {
      return item.id === props.data._setupArea.id;
    });

    return (
      <>
        <Text bold>Market</Text>
        <Text>{props.data._setupArea.name}</Text>
        <Button
          text="Add Market to Your Team"
          size={ButtonSize.SMALL}
          isFlat
          variant={ButtonVariant.FILLED}
          isDisabled={isAdded}
          title={isAdded ? 'Market already added' : undefined}
          onClick={async () => {
            await teamSetupAreasService.addSetupArea({
              setupAreaId: props.data._setupArea.id,
              setupAreaVersion: props.data._setupArea.version
            });
            popupManager.closePopup();
          }}
        />

      </>
    );
  } else {
    return null;
  }
}

export default function RequestInfoPopup(
  props: {
    data: MarketRequest
  }
) {
  return (
    <Popup
      title={props.data.name}
      content={(
        <ShowContext data={props.data}>
          <Text bold>Request Title</Text>
          <TextField source="name" label="Market Name" />
          <Text bold>Status</Text>
          <RequestStatusField />
          <Text bold>Description</Text>
          <WysiwygField source="description" label="Description" />
          <Text bold>Attached Files</Text>
          <AttachedFiles />
          {props.data.resultDescription && (
            <>
              <Text bold>Response</Text>
              <WysiwygField source="resultDescription" label="Response" />
            </>
          )}
          <ApplyMarketField data={props.data} />
        </ShowContext>
      )}
    />
  );
}


